/**
 * お気に入りクラス
 */
class Favorite {
  /**
   * お気に入り物件追加
   * @param {Array} officeIds 物件Id
   */
  static async add(officeIds) {
    // 送信データ
    const data = {
      office_ids: officeIds
    };

    // お気に入り物件追加リクエスト
    return await axios.post(route('web.favorite.add'), data)
      // 成功
      .then(response => {
        // APIリクエストの成否チェック
        if (!response.data.status) {
          throw new Error(response.data.message);
        }
        return response;
      })
      // 失敗
      .catch(error => {
        return error;
      })
  }

  /**
   * お気に入り物件削除
   * @param {Array} officeIds 物件ID
   */
  static async remove(officeIds) {
    // 送信データ
    const data = {
      office_ids: officeIds
    };

    // お気に入り物件削除リクエスト
    return await axios.post(route('web.favorite.remove'), data)
      // 成功
      .then(response => {
        // APIリクエストの成否チェック
        if (!response.data.status) {
          throw new Error(response.data.message);
        }
        return response;
      })
      // 失敗
      .catch(error => {
        debug.error(error);

        return error;
      })
  }

  /**
   * お気に入り登録の物件IDを取得
   */
  static async getOfficeIds() {
    // お気に入り物件取得リクエスト
    return await axios.get(route('web.favorite.ids'))
      // 成功
      .then(response => {
        // APIリクエストの成否チェック
        if (!response.data.status) {
          throw new Error(response.data.message);
        }

        return response;
      })
      // 失敗
      .catch(error => {
        debug.error(error);

        return error;
      })
  }
}

export default Favorite;
